import { useEffect, useState } from "react";
import {
  getUsers,
  rehydrateUsers,
  setAllUsers,
  subscribeUsers,
  type UserRecord,
} from "../store/usersStore";

export function useUsers() {
  const [users, setUsers] = useState<UserRecord[]>(() => getUsers());

  useEffect(() => {
    rehydrateUsers();

    const unsubscribe = subscribeUsers(() => {
      setUsers(getUsers());
    });

    setUsers(getUsers());

    return () => {
      unsubscribe();
    };
  }, []);

  return {
    users,
    setAllUsers,
  };
}